import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/Button';

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Render error caught by boundary:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <AlertTriangle className="w-12 h-12 text-red-500 mb-4" />
        <h2 className="text-lg font-semibold text-slate-800 mb-1.5">Something went wrong on this page</h2>
        <p className="text-sm text-slate-500 mb-4 max-w-md">
          The page hit an unexpected error. Reloading usually clears it. If it keeps happening, let an administrator know.
        </p>
        <Button size="sm" onClick={() => window.location.reload()}>
          Reload page
        </Button>
        {process.env.NODE_ENV !== 'production' && (
          <pre className="mt-4 text-xs text-left text-red-600 bg-red-50 border border-red-200 rounded p-3 max-w-full overflow-auto">
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        )}
      </div>
    );
  }
}
